export default __webpack_public_path__ + "ba44721c975845ad8f421122ef421ce4.svg";